import React from 'react';
import MenuDishEdit from './MenuDishEdit';
import FormsySimpleInput from '../form/FormsySimpleInput';
import SimpleInput from '../form/SimpleInput';
import SVGClose from '../../svg/Close';
import { calcAvgDishPrice } from '../../helpers/util';
import { maskMoney } from '../../masks';

class MenuCourseEdit extends React.Component {
  render() {
    const { handleChange } = this;
    const { name, description, dishes } = this.props.course;
    const { index, openModal, deleteCourse } = this.props;
    return (
      <div className="course cms__section">
        <div className="cms__section-body">
          <div className="course__delete" onClick={() => deleteCourse(index)}>
            <SVGClose />
          </div>
          <div className="course__head">
            <FormsySimpleInput
              type="text"
              name="name"
              placeholder="Name"
              className="simple-input simple-input--center simple-input--pad-bot simple-input--bold"
              value={name || ''}
              onChange={handleChange}
              required
            />
            <SimpleInput
              type="text"
              name="description"
              placeholder="Description"
              className="simple-input simple-input--center simple-input--pad-bot"
              value={description || ''}
              onChange={handleChange}
            />
          </div>

          {this.renderDishes(dishes, index)}

          <div
            className="btn btn--white btn--full-width"
            onClick={() => openModal('dish', { courseIndex: index })}
          >
            + Add Dish
          </div>
          <div className="course__price">
            <p className="p p--bold">
              Average Dish Price:{' '}
              <span className="p p--green">
                {maskMoney(calcAvgDishPrice(dishes))}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }

  renderDishes(dishes = [], index) {
    const { deleteDish, openModal, editMenuDish } = this.props;

    if (dishes && dishes.length > 0)
      return (
        <table className="table">
          <thead className="table__thead">
            <tr>
              <th className="table__th table__th--black">
                <p className="p p--bold">Dish Name</p>
              </th>
              <th className="table__th table__th--black">
                <p className="p p--bold">Ingredients</p>
              </th>
              <th className="table__th table__th--black">
                <p className="p p--bold">Price (sm)</p>
              </th>
              <th className="table__th table__th--black">
                <p className="p p--bold">Diet</p>
              </th>
              <th className="table__th table__th--black">
                <p className="p p--bold">Allergens</p>
              </th>
              <th className="table__th table__th--black"></th>
              <th className="table__th table__th--black"></th>
            </tr>
          </thead>
          <tbody>
            {dishes.map((dish, i) => (
              <MenuDishEdit
                key={i}
                dish={dish}
                courseIndex={index}
                dishIndex={i}
                deleteDish={deleteDish}
                editMenuDish={editMenuDish}
                openModal={openModal}
              />
            ))}
          </tbody>
        </table>
      );
  }

  handleChange = e => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    const course = { ...this.props.course };
    course[name] = value;

    this.props.updateCourse(this.props.index, course);
  };
}

export default MenuCourseEdit;



// WEBPACK FOOTER //
// ./src/components/menu/MenuCourseEdit.js